// extracted by mini-css-extract-plugin
export default {"form":"_wJGiG5X3DHX97UYTIAa"};